export const textTransformation = (text) => {
  return '<div style="font-family: sans-serif; padding:36px; font-size:40px;">' + text + "</div>";
};
